import { createContext, useContext, useState, useEffect } from "react";
import api from "../configs/api";
import { showSuccess } from "../utils/toastUtils";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("userData");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [adminUser, setAdminUser] = useState(() => {
    const storedAdmin = localStorage.getItem("adminData");
    return storedAdmin ? JSON.parse(storedAdmin) : null;
  });
  const [loading, setLoading] = useState(true);
  const [hydrated, setHydrated] = useState(false);

  //  Check authentication on mount
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const storedUser = localStorage.getItem("userData");
        const storedToken = localStorage.getItem("authToken");

        if (storedUser && storedToken) {
          setUser(JSON.parse(storedUser));
        }

        const storedAdmin = localStorage.getItem("adminData");
        const storedAdminToken = localStorage.getItem("adminToken");

        if (storedAdmin && storedAdminToken) {
          setAdminUser(JSON.parse(storedAdmin));
        }

        // We verify tokens by making calls. 
        // We can check normal user if token exists.
        if (storedToken) {
          try {
            const res = await api.get("/auth/me", { headers: { Authorization: `Bearer ${storedToken}` } });
            if (res.data?.user) {
              setUser(res.data.user);
              localStorage.setItem("userData", JSON.stringify(res.data.user));
            }
          } catch(err) {
            setUser(null);
            localStorage.removeItem("userData");
            localStorage.removeItem("authToken");
          }
        } else {
          setUser(null);
        }

        if (storedAdminToken) {
          try {
            const res = await api.get("/admin-auth/me", { headers: { Authorization: `Bearer ${storedAdminToken}` } });
            if (res.data?.user) {
              setAdminUser(res.data.user);
              localStorage.setItem("adminData", JSON.stringify(res.data.user));
            }
          } catch(err) {
            setAdminUser(null);
            localStorage.removeItem("adminData");
            localStorage.removeItem("adminToken");
          }
        } else {
          setAdminUser(null);
        }

      } catch (err) {
        console.warn("Auth check failed:", err.message);
      } finally {
        setHydrated(true);
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const requestOtp = async (phone) => {
    const res = await api.post("/auth/request-otp", { phone });
    return res.data;
  };

  const resendOtp = async (phone) => {
    try {
      setLoading(true);
      await api.post("/auth/resend-otp", { phone });
    } catch (err) {
      console.error(err.response?.data?.message || "Failed to resend OTP");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async (payload) => {
    const res = await api.post("/auth/verify-otp", payload);

    // Existing user (auto login)
    if (res.data?.isRegistered && res.data.user && res.data.token) {
      setUser(res.data.user);
      localStorage.setItem("userData", JSON.stringify(res.data.user));
      localStorage.setItem("authToken", res.data.token);
    }

    return res.data;
  };

  const completeRegistration = async (data) => {
    const res = await api.post("/auth/complete-registration", data);

    if (res.data?.user && res.data?.token) {
      setUser(res.data.user);
      localStorage.setItem("userData", JSON.stringify(res.data.user));
      localStorage.setItem("authToken", res.data.token);
    }

    return res.data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
      showSuccess("Logged out successfully.");
    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      setUser(null);
      localStorage.removeItem("userData");
      localStorage.removeItem("authToken");
    }
  };

  const adminLogout = async () => {
    try {
      setAdminUser(null);
      localStorage.removeItem("adminData");
      localStorage.removeItem("adminToken");
      showSuccess("Admin logged out successfully.");
    } catch (err) {
      console.error("Admin Logout error:", err);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        adminUser,
        setAdminUser,
        loading,
        hydrated,
        requestOtp,
        resendOtp,
        verifyOtp,
        completeRegistration,
        logout,
        adminLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

// import { createContext, useContext, useState, useEffect } from "react";
// import api from "../configs/api";
// import { showSuccess } from "../utils/toastUtils";

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(() => {
//     const storedUser = localStorage.getItem("userData");
//     return storedUser ? JSON.parse(storedUser) : null;
//   });
//   const [loading, setLoading] = useState(true);
//   const [hydrated, setHydrated] = useState(false);

//   //  Check current user on mount
//   useEffect(() => {
//     const checkAuth = async () => {
//       try {
//         const storedUser = localStorage.getItem("userData");
//         if (storedUser) setUser(JSON.parse(storedUser));

//         const res = await api.get("/auth/me", { withCredentials: true });
//         if (res.data?.user) {
//           setUser(res.data.user);
//           localStorage.setItem("userData", JSON.stringify(res.data.user));
//         } else {
//           setUser(null);
//           localStorage.removeItem("userData");
//         }
//       } catch (err) {
//         console.warn("Auth check failed:", err.message);
//         setUser(null);
//         localStorage.removeItem("userData");
//       } finally {
//         setHydrated(true);
//         setLoading(false);
//       }
//     };
//     checkAuth();
//   }, []);

//   const requestOtp = async (phone) => {
//     const res = await api.post("/auth/request-otp", { phone });
//     return res.data;
//   };
//   const resendOtp = async (phone) => {
//     try {
//       setLoading(true);
//       await api.post("/auth/resend-otp", { phone });
//     } catch (err) {
//       console.error(err.response?.data?.message || "Failed to resend OTP");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const verifyOtp = async (payload) => {
//     const res = await api.post("/auth/verify-otp", payload, {
//       withCredentials: true,
//     });

//     // Existing user (auto login)
//     if (res.data?.isRegistered && res.data.user) {
//       setUser(res.data.user);
//       localStorage.setItem("userData", JSON.stringify(res.data.user));
//     }

//     // New user -> requires registration
//     return res.data;
//   };

//   const completeRegistration = async (data) => {
//     const res = await api.post("/auth/complete-registration", data, {
//       withCredentials: true,
//     });
//     setUser(res.data.user);
//     localStorage.setItem("userData", JSON.stringify(res.data.user));
//     return res.data;
//   };

//   //  Logout
//   const logout = async () => {
//     try {
//       await api.post("/auth/logout", {}, { withCredentials: true });
//       showSuccess("Logged out successfully.");
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setUser(null);
//       localStorage.removeItem("userData");
//     }
//   };

//   return (
//     <AuthContext.Provider
//       value={{
//         user,
//         setUser,
//         loading,
//         hydrated,
//         requestOtp,
//         resendOtp,
//         verifyOtp,
//         completeRegistration,
//         logout,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// // Custom hook for convenience
// export const useAuth = () => useContext(AuthContext);
